import React from 'react'
require('~/stylesheets/genericpagenotfound.css');

import OfflineWeb from '~/assets/images/genericpagenotfound/noweb-desktop.png'
import OfflineMob from '~/assets/images/genericpagenotfound/noweb-mobile.png'

import Button from '~/Common-Objects/UI/Forms/Button/Button';
import Column from '~/Common-Objects/Grids/Column/Column';
import Row from '~/Common-Objects/Grids/Row/Row';

export default class NotFoundOutPut extends React.Component {
  constructor(props) {
    super(props);
    this.tryAgain = this.tryAgain.bind(this);
  }

  tryAgain() {
    this.props.history.goBack();
    // window.history.back();
  }

  render() {
    return <div className="container-fluid">
      <Row className="center-xs middle-xs around-xs" style={{ height: "100vh" }}>
        <Column>
          <img src={OfflineWeb} style={{ width: "100%", maxWidth: "100px" }} className="mar-b25" />
          <h1 className="mar-b15">Oh No!</h1>
          <h4 style={{ marginBottom: "30px" }}>The interweb has disappeared</h4>
          <Button text="Try Again..." onClick={this.tryAgain} />
        </Column>
      </Row >
    </div >
  }
};